import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import CategoryGrid from '../components/CategoryGrid';
import NewProducts from '../components/NewProducts';
import BrandLogos from '../components/BrandLogos';
import CustomBuild from '../components/CustomBuild';
import PosturalStudies from '../components/PosturalStudies';
import AtelierLavage from '../components/AtelierLavage';
import InstagramGallery from '../components/InstagramGallery';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <>
      <Header />
      <Hero />
      <CategoryGrid />
      <NewProducts />
      <BrandLogos />
      <CustomBuild />
      <PosturalStudies />
      <AtelierLavage />
      <InstagramGallery />
      <Newsletter />
      <Footer />
    </>
  );
};

export default HomePage;

